import React from "react";
import {
  Drawer,
  Input,
  Typography,
  Card,
  Tag,
  Button,
  Divider,
  Avatar,
  Timeline,
  Space,
  Row,
  Col,
  Badge,
} from "antd";
import CurrencyFormat from "react-currency-format";
import FileUpload from "./FileUpload";
import FilePreviewer from "./FilePreviewer";
import RouteMap from "./RouteMap";
const moment = require("moment");

const { Title, Text, Paragraph } = Typography;

const OrderDetails = ({
  order,
  startChat,
  setStartChat,
  setOrder,
  orderFiles,
  orderconversations,
  getOrderFiles,
  getOrderConversations,
  newComment,
  setNewComment,
  addingConversation,
  addConversation,
  getImage,
  onDownloadInvoice,
  payUrl,
  orderPaid,
  downloadingInvoice,
}) => {
  if (!order) return null;
  const image = getImage(order?.trucktype);
  const showTripActions = onDownloadInvoice || payUrl || orderPaid;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "finished":
        return "success";
      case "cancelled":
        return "error";
      case "pending":
        return "warning";
      default:
        return "processing";
    }
  };

  return (
    <Drawer
      onClose={() => {
        setStartChat("a");
        setOrder(null);
      }}
      open={startChat === "ax-x-x" + order.orderid}
      width={"100%"}
      title={
        <Space>
          <Title level={4} style={{ margin: 0 }}>
            Order #{order.orderid?.split("-")[0]}
          </Title>
          <Badge
            status={getStatusColor(order.orderstatus)}
            text={
              <Text strong>
                {order.orderstatus === "finished"
                  ? "Completed"
                  : order.orderstatus}
              </Text>
            }
          />
        </Space>
      }
      extra={
        <Tag color={getStatusColor(order.deliverystatus)}>
          {order.deliverystatus}
        </Tag>
      }
      bodyStyle={{ padding: "24px", background: "#f5f5f5" }}
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card>
            <Row gutter={[24, 16]} align="middle">
              <Col xs={24} md={4}>
                <div style={{ textAlign: "center" }}>
                  <Avatar size={64} src={image} />
                  <div style={{ marginTop: 8 }}>
                    <Text strong>{order?.trucktype}</Text>
                  </div>
                  <Text type="secondary">{order?.licenseplatenumber}</Text>
                </div>
              </Col>
              <Col xs={24} md={10}>
                <Space direction="vertical" size={1} style={{ width: "100%" }}>
                  <Text type="secondary">Customer</Text>
                  <Text strong>{order.firstname}</Text>
                  <Text>{order.email}</Text>
                  <Text>{order.mobilenumber}</Text>
                </Space>
              </Col>
              <Col xs={24} md={10}>
                <Space direction="vertical" size={1} style={{ width: "100%" }}>
                  <Text type="secondary">Driver</Text>
                  <Text strong>{order.driverfirstname || "Not assigned"}</Text>
                  <Text>{order.drivermobilenumber || "N/A"}</Text>
                </Space>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={24} md={16}>
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <Card title="Order Information">
                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                  <div>
                    <Text type="secondary">Description</Text>
                    <Paragraph>{order.description}</Paragraph>
                  </div>

                  <div>
                    <Text type="secondary">Collection Address</Text>
                    <Paragraph>{order.collectionaddress}</Paragraph>
                  </div>

                  <div>
                    <Text type="secondary">Delivery Address</Text>
                    <Paragraph>{order.deliveryaddress}</Paragraph>
                  </div>

                  <div>
                    <Text type="secondary">Price</Text>
                    <div>
                      <CurrencyFormat
                        value={order.sellingprice / 100}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"R"}
                        decimalScale={2}
                        renderText={(value) => (
                          <Title level={3} style={{ margin: 0 }}>
                            {value}
                          </Title>
                        )}
                      />
                    </div>
                  </div>

                  <Row gutter={16} style={{ marginTop: 16 }}>
                    <Col span={8}>
                      <div style={{ 
                        background: '#f5f5f5', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Helpers</Text>
                        <div style={{ fontSize: 18, fontWeight: 600 }}>{order.runners || 0}</div>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div style={{ 
                        background: '#f5f5f5', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Floors</Text>
                        <div style={{ fontSize: 18, fontWeight: 600 }}>{order.floors || 0}</div>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div style={{ 
                        background: order.trips > 1 ? '#fff7e6' : '#f5f5f5', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: order.trips > 1 ? '1px solid #ffd591' : 'none'
                      }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Trips</Text>
                        <div style={{ 
                          fontSize: 18, 
                          fontWeight: 600,
                          color: order.trips > 1 ? '#d46b08' : 'inherit'
                        }}>
                          {order.trips || 1}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Space>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col xs={24} md={8}>
          {showTripActions ? (
            <Card title="Invoice & payment" style={{ marginBottom: 16 }}>
              <Space direction="vertical" style={{ width: "100%" }} size={12}>
                {onDownloadInvoice ? (
                  <Button
                    type="primary"
                    block
                    loading={downloadingInvoice}
                    onClick={() => onDownloadInvoice(order.orderid)}
                  >
                    Download invoice PDF
                  </Button>
                ) : null}
                {payUrl ? (
                  <Button block href={payUrl} target="_blank" rel="noopener noreferrer">
                    Pay with PayFast
                  </Button>
                ) : null}
                {orderPaid && !payUrl ? (
                  <Text type="success">Trip marked paid</Text>
                ) : null}
              </Space>
            </Card>
          ) : null}
          <Card title="Files">
            <div style={{ marginBottom: 20 }}>
              <FileUpload
                orderid={order.orderid}
                getOrderFiles={getOrderFiles}
                getOrderConversations={getOrderConversations}
              />
            </div>

            {orderFiles?.length > 0 ? (
              <Space direction="vertical" style={{ width: "100%" }}>
                {orderFiles?.map((o, index) => (
                  <FilePreviewer
                    orderfile={{
                      ...order,
                      ...o,
                      orderid: order.orderid,
                    }}
                    key={o + index}
                    getOrderFiles={getOrderFiles}
                    getOrderConversations={getOrderConversations}
                  />
                ))}
              </Space>
            ) : (
              <div
                style={{
                  padding: "10px 0",
                  color: "#999",
                  textAlign: "center",
                }}
              >
                <Text type="secondary">No files uploaded</Text>
              </div>
            )}
          </Card>
        </Col>
        <Col span={24}>
          <RouteMap order={order} />
        </Col>
        <Col span={24}>
          <Card
            title="Comments"
            extra={
              <Text type="secondary">
                {orderconversations.length}{" "}
                {orderconversations.length === 1 ? "comment" : "comments"}
              </Text>
            }
          >
            {orderconversations.length > 0 ? (
              <Timeline style={{ marginTop: 20 }}>
                {orderconversations.map((o) => (
                  <Timeline.Item key={o.orderconversationid}>
                    <div style={{ marginBottom: 16 }}>
                      <Space align="baseline">
                        <Text strong>
                          {o.adminfirstname ||
                            o.customerfirstname ||
                            o.driverfirstname}
                        </Text>
                        <Text type="secondary">
                          {moment(o.dateadded).format("ddd MMM DD hh:mm a")}
                        </Text>
                      </Space>
                      <div style={{ marginTop: 8 }}>
                        <Text>
                          {(() => {
                            const raw = o.message || "";
                            try {
                              const parsed = JSON.parse(raw);
                              if (
                                parsed &&
                                parsed.type === "order-updated" &&
                                parsed.changes
                              ) {
                                const entries = Object.entries(parsed.changes);
                                if (entries.length > 0) {
                                  const formatVal = (v) =>
                                    v === null || v === undefined || v === ""
                                      ? "-"
                                      : String(v);
                                  return entries
                                    .map(
                                      ([field, change]) =>
                                        `${field}: ${formatVal(
                                          change?.from
                                        )} → ${formatVal(change?.to)}`
                                    )
                                    .join(" | ");
                                }
                              }
                            } catch (e) {
                              // fall back to plain text below
                            }
                            return raw.replace("[SMS] ", "");
                          })()}
                        </Text>
                      </div>
                    </div>
                  </Timeline.Item>
                ))}
              </Timeline>
            ) : (
              <Text type="secondary">No comments yet</Text>
            )}

            <Divider />

            <div>
              <Input.TextArea
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                placeholder="Record any information about the job here. Admins and drivers can see this information."
                autoSize={{ minRows: 3, maxRows: 6 }}
                style={{ marginBottom: 16 }}
              />
              <Button
                type="primary"
                disabled={addingConversation || newComment.length === 0}
                onClick={() => addConversation(order.orderid)}
                loading={addingConversation}
              >
                Add Comment
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </Drawer>
  );
};

export default OrderDetails;
